import { useState } from "react";
import { toast } from "sonner";
import { Search, Camera } from "lucide-react";
import QrScanner from "../../components/shared/QrScanner";

export default function ScanBar({ onResolve, scanOpen, setScanOpen }) {
  const [q, setQ] = useState("");
  const submit = () => {
    if (!q.trim()) return toast.error("Scan or type a ticket, wallet, coupon or email");
    onResolve(q.trim());
  };
  return (
    <div className="bg-white rounded-2xl p-3 shadow-sm mb-5 border border-slate-100" data-testid="desk-scan-bar">
      <div className="flex gap-2">
        <input value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === "Enter" && submit()}
          placeholder="Ticket, wallet, coupon or email"
          className="flex-1 min-w-0 px-3 py-3 rounded-xl border text-sm" data-testid="desk-scan-input" />
        <button onClick={submit} className="px-3.5 rounded-xl bg-slate-100 text-[#1e3a5f] hover:bg-slate-200 transition-colors" aria-label="Search" data-testid="desk-scan-search-btn"><Search className="w-5 h-5" /></button>
        <button onClick={() => setScanOpen(true)} className="px-3.5 rounded-xl bg-[#1e3a5f] text-white hover:bg-[#2d5a8f] transition-colors" aria-label="Scan" data-testid="desk-scan-camera-btn"><Camera className="w-5 h-5" /></button>
      </div>
      {scanOpen && <QrScanner onScan={(t) => { setScanOpen(false); onResolve(t); }} onClose={() => setScanOpen(false)} />}
    </div>
  );
}
